import React, { FC } from "react";
import classNames from "classnames";

import Button, { ButtonProps } from "@material-ui/core/Button";
import { makeStyles, Theme } from "@material-ui/core/styles";

import Icon from "shared/components/Icon";

import arrowDown from "assets/icons/keyboard_arrow_down.svg";

const useStyles = makeStyles((theme: Theme) => {
  return {
    button: {
      padding: `${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
      border: "1px solid rgba(255, 255, 255, 0.25)",
    },
  };
});

const HeaderButton: FC<ButtonProps> = ({ children, className, ...props }) => {
  const classes = useStyles();

  return (
    <Button
      className={classNames(classes.button, className)}
      color="inherit"
      {...props}
    >
      {children}
      <Icon src={arrowDown} />
    </Button>
  );
};

export default HeaderButton;
